import axios from 'axios';
import TagsApi from 'bundles/tags/tags_api';
import { isPresent } from 'helpers/string_helpers';

export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export function clearFilters() {
  return { type: CLEAR_FILTERS };
}

export const CHANGE_COMPANY_PAGE = 'CHANGE_COMPANY_PAGE';
export function changeCompanyPage(page) {
  axios.post('/contacts/companies/set_page', { company_page: page });
  return { page: page, type: CHANGE_COMPANY_PAGE };
}

export const CHANGE_COMPANY_SORT = 'CHANGE_COMPANY_SORT';
export function changeCompanySort(sort) {
  return { sort: sort, type: CHANGE_COMPANY_SORT };
}

export const CHANGE_PERSON_PAGE = 'CHANGE_PERSON_PAGE';
export function changePersonPage(page) {
  axios.post('/contacts/people/set_page', { person_page: page });
  return { page: page, type: CHANGE_PERSON_PAGE };
}

export const CHANGE_PERSON_SORT = 'CHANGE_PERSON_SORT';
export function changePersonSort(sort) {
  return { sort: sort, type: CHANGE_PERSON_SORT };
}

export const CHANGE_RELATED_SEARCH = 'CHANGE_RELATED_SEARCH';
export function changeRelatedSearch(searchId) {
  return { id: searchId, type: CHANGE_RELATED_SEARCH };
}

export const CHANGE_SEARCH_TEXT = 'CHANGE_SEARCH_TEXT';
export function changeSearchText(value) {
  return (dispatch) => {
    if (isPresent(value)) {
      dispatch(changePersonSort(null));
      dispatch(changeCompanySort(null));
    }

    dispatch({ value: value, type: CHANGE_SEARCH_TEXT });
  };
}

export const CLEAR_RELATED_MODEL_FILTERS = 'CLEAR_RELATED_MODEL_FILTERS';
export function clearRelated() {
  return { type: CLEAR_RELATED_MODEL_FILTERS };
}

export const TOGGLE_ROLE = 'TOGGLE_ROLE';
export function toggleRole(key, checked) {
  return { role: key, checked: checked, type: TOGGLE_ROLE };
}

export const SELECT_EXCLUDE_TAGS = 'SELECT_EXCLUDE_TAGS';
export function selectExcludeTags() {
  return { type: SELECT_EXCLUDE_TAGS };
}

export const SET_TAGS = 'SET_TAGS';
export function setTags(tags) {
  return { tags: tags, type: SET_TAGS };
}

export const SET_PROPERTY_IDS = 'SET_PROPERTY_IDS';
export function setPropertyIds(propertyIds) {
  return { propertyIds: propertyIds, type: SET_PROPERTY_IDS };
}


export const SET_BACK_TO_LINK = 'SET_BACK_TO_LINK';
export function setBackToLink(link) {
  return { link: link, type: SET_BACK_TO_LINK };
}

export const SET_COMPANIES_GROUP_FILTER_IDS = 'SET_COMPANIES_GROUP_FILTER_IDS';
export function setCompaniesGroupFilterIds(groupIds) {
  return { groupIds, type: SET_COMPANIES_GROUP_FILTER_IDS };
}

export const ADD_COMPANIES_GROUP_FILTER_ID = 'ADD_COMPANIES_GROUP_FILTER_ID';
export function addCompaniesGroupFilterId(groupId) {
  return { groupId, type: ADD_COMPANIES_GROUP_FILTER_ID };
}

export const REMOVE_COMPANIES_GROUP_FILTER_ID = 'REMOVE_COMPANIES_GROUP_FILTER_ID';
export function removeCompaniesGroupFilterId(groupId) {
  return { groupId, type: REMOVE_COMPANIES_GROUP_FILTER_ID };
}

export const SET_PEOPLE_GROUP_FILTER_IDS = 'SET_PEOPLE_GROUP_FILTER_IDS';
export function setPeopleGroupFilterIds(groupIds) {
  return { groupIds: groupIds, type: SET_PEOPLE_GROUP_FILTER_IDS };
}

export const ADD_PEOPLE_GROUP_FILTER_ID = 'ADD_PEOPLE_GROUP_FILTER_ID';
export function addPeopleGroupFilterId(groupId) {
  return { groupId, type: ADD_PEOPLE_GROUP_FILTER_ID };
}

export const REMOVE_PEOPLE_GROUP_FILTER_ID = 'REMOVE_PEOPLE_GROUP_FILTER_ID';
export function removePeopleGroupFilterId(groupId) {
  return { groupId, type: REMOVE_PEOPLE_GROUP_FILTER_ID };
}

export const SET_ROLES = 'SET_ROLES';
export function setRoles(roles) {
  return { roles: roles, type: SET_ROLES };
}

export function clearFiltersIfEmpty() {
  return (dispatch, getState) => {
    const query = getState().query;
    const tags = query.tags;
    const roles = query.roles;
    const propertyIds = query.propertyIds;
    if (tags.length === 0 && roles.length === 0 && propertyIds.length === 0 && query.searchText === '') {
      dispatch(clearFilters());
    }
  };
}

export function getTags(tagNames) {
  return (dispatch, getState) => {
    const { paths: { tags } } = getState();
    const api = new TagsApi(tags);
    api.searchTags('', tagNames).then((tags) => {
      dispatch(setTags(tags));
    });
  };
}
